import { createSelector, weakMapMemoize } from 'reselect'
import getBedbankItems from './getBedbankItems'

/** Undefined until checkout has (re)created the enquiry for this property's cart item. */
const getBedbankEnquiry = createSelector(
  (state: App.State) => getBedbankItems(state),
  (state: App.State) => state.checkout.sessions,
  (_state: App.State, propertyId: string) => propertyId,
  (items, sessions, propertyId): App.BedbankEnquiry | undefined => {
    const sessionId = items.find(item => item.offerId === propertyId)?.sessionId
    return sessionId ? sessions[sessionId]?.data ?? undefined : undefined
  },
  { memoize: weakMapMemoize, argsMemoize: weakMapMemoize },
)

export default getBedbankEnquiry
